var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNigerFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2045_55615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.3335C1.95942 3.3335 1.28115 3.61445 0.781049 4.11454C0.280952 4.61464 0 5.29292 0 6.00016L0 18.0002C0 18.7074 0.280952 19.3857 0.781049 19.8858C1.28115 20.3859 1.95942 20.6668 2.66667 20.6668H8V3.3335H2.66667Z",
    fill: "#009A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.3335H16V20.6668H8V3.3335Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 3.3335H16V20.6668H21.3333C22.0406 20.6668 22.7189 20.3859 23.219 19.8858C23.719 19.3857 24 18.7074 24 18.0002V6.00016C24 5.29292 23.719 4.61464 23.219 4.11454C22.7189 3.61445 22.0406 3.3335 21.3333 3.3335Z",
    fill: "#009A49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2045_55615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigerFlag);
export default __webpack_public_path__ + "static/media/NigerFlag.e7f572f2c0fa648389e779787e517ebe.svg";
export { ForwardRef as ReactComponent };